<template>
  <div class="marketplace-logo py-lg-6 px-lg-6"
       :class="{'affiliate-app-nav-logo-marketplace': !!affiliateCustomizations}">
    <!-- Affiliate Logo -->
    <a
      v-if="(useAffiliateLogo && !!affiliateLogoUrl) || customCobrandAffiliates.includes(affiliateId)"
      :href="appNavUrl"
      :class="affiliateStyles"
    >
      <NuxtImg class="affiliate" :src="formatImagePath(affiliateLogoUrl)" :alt="`${affiliateName}-logo`" />
      <NuxtImg v-if="isCredibilityCapital" src="/images/Lendio-Logo-2024.svg" alt="Lendio" />
    </a>
    <!-- Affiliate Customizations Logo -->
    <a v-else-if="!!affiliateCustomizations && !!appNavLogo" :href="appNavUrl">
      <NuxtImg :src="formatImagePath(appNavLogo)" alt="" />
    </a>
    <!-- Default Logo -->
    <a v-else class="navbar-brand" :href="appNavUrl">
      <NuxtImg src="/images/Lendio-Logo-2024.svg" width="132" alt="Lendio" />
    </a>
  </div>
</template>

<script>
import {mapState} from "pinia";
import {useCobrandStore} from "~/store/cobrand"
import env from "~/libs/env";
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import formatImagePath from '~/libs/image-format'

export default {
  name: "MarketplaceLogo",
  setup() {
    return { formatImagePath }
  },
  data() {
    return {
      hpUrl: env('hpBaseUrl'),
      themeLogo: env('themeLogo'),
    }
  },
  computed: {
    ...mapState(useCobrandStore, {
      cobrandConfig: store => store.config,
      customCobrandAffiliates: store => store.customCobrandAffiliates,
      useAffiliateLogo: store => store.affiliateCobrandEnabled,
    }),
    ...mapState(useAffiliateCustomizationStore, ['appNavLogo', 'appNavLogoUrl', 'affiliateCustomizations']),
    affiliateId() {
      return this.cobrandConfig && parseInt(this.cobrandConfig.affiliateId)
    },
    affiliateLogoLink() {
      return this.cobrandConfig && this.cobrandConfig.link
    },
    affiliateLogoUrl() {
      if (this.isCredibilityCapital) {
        return '/images/CredCapital_LOGO.png'
      } else if (this.isHeartland) {
        return '/images/heartland-logo.svg'
      }
      return this.cobrandConfig ? this.cobrandConfig.logoUrl : ''
    },
    affiliateName() {
      if (this.isCredibilityCapital) {
        return 'credibility-capital'
      } else if (this.isHeartland) {
        return 'heartland'
      }
      return this.cobrandConfig.slug
    },
    affiliateStyles() {
      const credibilityClasses = 'credibility-combined-logo d-flex flex-column justify-content-between align-items-start'
      return this.isCredibilityCapital ? credibilityClasses : ''
    },
    isCredibilityCapital() {
      return this.affiliateId === 3610136120
    },
    isHeartland() {
      return this.affiliateId === 1539022715
    },
    themeLogoUrl() {
      return this.themeLogo
    },
    appNavUrl () {
      return this.appNavLogoUrl ?? this.hpUrl
    }
  },
}
</script>

<style lang="scss" scoped>
@import 'assets/styles/affiliate-customizations/affiliate-customization-mixins';

.marketplace-logo {
  max-width: 60%;
  display: flex;
  align-items: center;
  @include media-breakpoint-up(lg) {
    max-width: 100%;
  }
  img {
    max-height: 28px;
    &.affiliate {
      @include media-breakpoint-up(lg) {
        max-height: 55px;
        max-width: 100%;
      }
    }

    &.affiliate-custom-logo {
      max-height: 60px;
      top: -32px;
      z-index: 1;
    }
  }
  .credibility-combined-logo {
    a {
      height: 28px;
    }
    img {
      max-height: 55px;
      &:first-of-type {
        margin-bottom: 2px;
        max-height: 8px;
        @include media-breakpoint-up(lg) {
          max-height: 14px;
        }
      }
      &:last-of-type {
        max-height: 16px;
        @include media-breakpoint-up(lg) {
          max-height: 29px;
        }
      }
    }
  }
  &.affiliate-app-nav-logo-marketplace {
    @include affiliateAppNavLogoMarketplace();
  }
}
</style>
